import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  FormLabel,
  Grid,
  IconButton,
  makeStyles,
  MenuItem,
  Select,
  Snackbar,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Theme,
  Typography,
} from "@material-ui/core";
import VisibilityIcon from "@material-ui/icons/Visibility";
import VisibilityOffIcon from "@material-ui/icons/VisibilityOff";
import { Alert } from "@material-ui/lab";
import React, { useEffect, useRef, useState } from "react";
import { CloseIcon, CloseIconColor, ExpandIconTwo } from "../../Icons";
import { TextBar } from "../TextBar";
import { primaryBlue, primaryGray, textBarColor } from "../../colors";
import { environment } from "src/environments/environment";
import axios from "axios";
import useStyles from "src/app/maintenance/assets/styles";
import Cookies from "js-cookie";
import { set } from "date-fns";

const localStyles = makeStyles((theme: Theme) => ({
  container: {
    paddingTop: "20px",
  },
  input: {
    width: "100%",
    height: "40px",
    backgroundColor: "#F4F5F7",
  },
  label: {
    fontSize: "14px",
    color: primaryGray,
    paddingBottom: "5px",
  },
  helperText: {
    color: "red",
  },
  divider: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
    height: 1,
    width: "100%",
  },
  textBarStyle: {
    backgroundColor: textBarColor,
    height: "44px",
  },
  textBarMessageStyle: {
    width: "219px",
    backgroundColor: textBarColor,
    height: "44px",
  },
  labelMessage: {
    fontSize: "14px",
    color: primaryGray,
    paddingBottom: "5px",
    width: "121px",
  },
  select: {
    width: "252px",
    border: "1px solid #ccc",
    borderRadius: "4px",
    backgroundColor: textBarColor,
    height: "44px",
    padding: "4px",
    fontSize: "14px",
  },
  menuItem: {
    fontSize: "14px",
  },
}));

const ExecuteCommandPopup = (props) => {
  const device = props.device.device.deviceParameterConfiguration;
  const { productType, versionNum, deviceCategory } =
    props.device.device.deviceParameterConfiguration;
  let commandArray = [];
  if (props.device.device.deviceParameterConfiguration.remoteConfigurations) {
    commandArray =
      props.device.device.deviceParameterConfiguration.remoteConfigurations.filter(p => { return p.isCommand == true }).sort(
        (a, b) => a.id - b.id
      );
  }
  const [commands, setCommands] = useState(commandArray);
  const [parametersToEdit, setParametersToEdit] = useState([]);
  const [updateMsgOpen, setUpdateMsgOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [toaster, setToaster] = useState(false);
  const [msgSuccess, setMsgSuccess] = useState(false);
  const [commandSent,setCommandSent]=useState({
    parameter:"",
    defaultValue:"",
    commandType:""
  })

  const classes = localStyles();
  const style = useStyles();
  const handleCloseToaster = () => {
    setToaster(false);
  };



  const handleExecuteClick = (command) => {

    setCommandSent(command);

    const uId = Cookies.get("USER_ID");
    const data = {
      productType,
      versionNum,
      deviceCategory,
      remoteConfigurations: [command],
    };
    setLoading(true);
    axios.put(`${environment.host}/core/device/deviceParameterConfiguration/${props.device.device.id}/user/${uId}`, data,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${Cookies.get("ACCESS_TOKEN")}`,
        },
      })
      .then((response) => {
        if (
          response.status === 200 &&
          response.data.message === "Success"
        ) {
          setUpdateMsgOpen(true);
          setTimeout(() => {
            setUpdateMsgOpen(false);
            setLoading(false);
            props.onClose();
          }, 2000);
        }
      })
      .catch((error) => {
        setLoading(false);
        setMessage(error.response.data.message);
        setMsgSuccess(false);
        setToaster(true);
        setTimeout(() => {
          setToaster(false);
        }, 2000);
        console.error(error);
      });
  };





  const handleCloseUpdateMsg = () => {
    setUpdateMsgOpen(false);
  };



  const keyOrder = ["productType", "versionNum", "deviceCategory", "deviceIds"];

  return (
    <div>
      <Dialog
        open={props.open}
        onClose={props.onClose}
        fullWidth={true}
        maxWidth={"md"}
        style={{ width: "766px", height: "591px" }}
        BackdropProps={{
          style: {
            backgroundColor: "cubic-bezier(0.4, 0, 0.1, 1)",
            opacity: "0.4",
          },
        }}
        PaperProps={{
          // className: classes.paper,
          style: {
            boxShadow: "inherit",
          },
        }}
      >
        <Grid
          container
          style={{
            width: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            opacity: "1",
            boxShadow: "0px 4px 30px #00000008",
          }}
        >
          <Grid item xs={10} md={10}>
            <DialogTitle>Execute Command/Action</DialogTitle>
          </Grid>
          <Grid
            item
            xs={2}
            md={2}
            className={style.customCloseIcon}
          >
            <IconButton onClick={props.onClose}>
              <CloseIconColor />
            </IconButton>
          </Grid>
        </Grid>
        <Divider />
        <>
        <DialogContent                          
                className={classes.container}
                style={{
                  width: "100%",
                  paddingBottom: "20px",
                  paddingRight:"0px",
                  display: "flex",
                }}>

              <Grid
                container
                className={classes.container}
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "start",
                  alignItems: "center",
                  paddingRight: "10px",
                  boxShadow: "0px 4px 30px #00000008",
                }}
              >

                <TableContainer>
                  <Table size="small">
                    <TableHead>
                      <TableRow>
                        <TableCell
                          style={{
                            textAlign: "left",
                            borderBottomColor: "white",
                            borderTopColor: "white",
                            backgroundColor: "white",
                          }}
                        >
                          <div style={{ display: "inline-flex" }}>
                            <Typography className={style.tablehead}
                              display="inline"
                            >
                              Command name
                            </Typography>
                          </div>
                        </TableCell>
                        <TableCell
                          style={{
                            textAlign: "left",
                            borderBottomColor: "white",
                            borderTopColor: "white",
                            backgroundColor: "white",
                          }}
                        >
                          <div style={{ display: "inline-flex" }}>
                            <Typography className={style.tablehead}
                              display="inline"
                            >
                              ID
                            </Typography>
                          </div>
                        </TableCell>
                        <TableCell
                          style={{
                            textAlign: "left",
                            borderBottomColor: "white",
                            borderTopColor: "white",
                            backgroundColor: "white",
                          }}
                        >
                          <div style={{ display: "inline-flex" }}>
                            <Typography className={style.tablehead}
                              display="inline"
                            >
                              Value
                            </Typography>
                          </div>
                        </TableCell>

                        <TableCell
                          style={{
                            textAlign: "left",
                            borderBottomColor: "white",
                            borderTopColor: "white",
                            backgroundColor: "white",
                          }}
                        >
                          <div style={{ display: "inline-flex" }}>
                            <Typography className={style.tablehead}
                            >
                              Action
                            </Typography>
                          </div>
                        </TableCell>
                      </TableRow>
                    </TableHead>

                  <TableBody>
                    {commands.length > 0 ?
                      commands
                        .map((ele, i) => {
                          return (
                            <TableRow key={ele.id}>
                              <TableCell
                                style={{
                                  textAlign: "left",
                                  borderBottomColor: "white",
                                  borderTopColor: "white",
                                  backgroundColor:
                                    i % 2 === 0 || i / 2 === 0
                                      ? "#F9F9F9"
                                      : "white",
                                }}
                              >
                                <Typography>
                                  {ele.parameter}
                                </Typography>
                              </TableCell>
                              <TableCell
                                style={{
                                  textAlign: "left",
                                  borderBottomColor: "white",
                                  borderTopColor: "white",
                                  backgroundColor:
                                    i % 2 === 0 || i / 2 === 0
                                      ? "#F9F9F9"
                                      : "white",
                                }}
                              >
                                <Typography>
                                  {ele.parameterId}
                                </Typography>
                              </TableCell>
                              <TableCell
                                style={{
                                  textAlign: "left",
                                  borderBottomColor: "white",
                                  borderTopColor: "white",
                                  backgroundColor:
                                    i % 2 === 0 || i / 2 === 0
                                      ? "#F9F9F9"
                                      : "white",
                                }}
                              >
                                <Typography>
                                  {ele.defaultValue}
                                </Typography>
                              </TableCell>
                              <TableCell
                                style={{
                                  textAlign: "left",
                                  borderBottomColor: "white",
                                  borderTopColor: "white",
                                  backgroundColor:
                                    i % 2 === 0 || i / 2 === 0
                                      ? "#F9F9F9"
                                      : "white",
                                }}
                              >
                                <Button className={style.buttonOK} onClick={() => handleExecuteClick(ele)}>Execute</Button>
                              </TableCell>
                            </TableRow>
                          )
                        })
                      : (
                        <TableRow>
                          <TableCell
                            colSpan={4}
                            style={{
                              textAlign: "center",
                              padding: "40px 16px",
                              borderBottom: "none",
                              backgroundColor: "#F9F9F9",
                            }}
                          >
                            <Typography
                              style={{
                                color: primaryGray,
                                fontSize: "14px",
                                fontStyle: "italic",
                              }}
                            >
                              No commands available
                            </Typography>
                          </TableCell>
                        </TableRow>
                      )}
                  </TableBody>
                  </Table>
                </TableContainer>
              </Grid>
          </DialogContent>
        </>
        <div>
          <Snackbar
            open={toaster}
            autoHideDuration={6000}
            onClose={handleCloseToaster}
            anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
          >
            <Alert
              onClose={handleCloseToaster}
              severity={msgSuccess === true ? "success" : "error"}
            >
              {message}
            </Alert>
          </Snackbar>
          {parametersToEdit.length > 0 && (
            <Snackbar
              key="parameterEditAlert"
              open={true}
              autoHideDuration={6000}
              onClose={() => setParametersToEdit([])}
            >
              <Alert severity="warning" onClose={() => setParametersToEdit([])}>
                You need to edit the following parameters:{" "}
                {parametersToEdit.join(",")}
              </Alert>
            </Snackbar>
          )}

          <Snackbar
            key="successAlert"
            open={updateMsgOpen}
            autoHideDuration={6000}
            onClose={handleCloseUpdateMsg}
            onClick={handleCloseUpdateMsg}
            anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
          >
            <Alert
              severity="success"
              onClose={handleCloseUpdateMsg}
            >
              <h3>{`Product Type : ${productType} -> Device : ${props.device.device.id} `}</h3>
              <p> {commandSent.parameter} {`command  sent `}</p>
            </Alert>
          </Snackbar>

        </div>
      </Dialog>
    </div>
  );
};



export default ExecuteCommandPopup;
